import { ZapTemplate, ZapTemplateResult } from './types';
import { useEffect, useState } from 'react';
import { urls } from '@zapier/identity-utils';

export function useZapTemplate(id: string | number | null) {
  const [isLoading, setIsLoading] = useState(true);
  const [zapTemplate, setZapTemplate] = useState<ZapTemplate | null>(null);

  useEffect(() => {
    async function getZapTemplate() {
      const response = await fetch(`${urls.ZAP_TEMPLATE_API_URL}/${id}/`);

      const rawTemplate = (await response.json()) as ZapTemplateResult;

      setIsLoading(false);

      if (!rawTemplate.id) {
        setZapTemplate(null);
        return;
      }

      setZapTemplate({
        headService: {
          id: rawTemplate.head_service?.id,
          image: rawTemplate.head_service?.image,
          name: rawTemplate.head_service?.name,
          reads: rawTemplate.head_service?.reads,
          slug: rawTemplate.head_service?.slug,
          writes: rawTemplate.head_service?.writes,
        },
        id: rawTemplate.id,
        tailService: {
          id: rawTemplate.tail_service?.id,
          image: rawTemplate.tail_service?.image,
          name: rawTemplate.tail_service?.name,
          reads: rawTemplate.tail_service?.reads,
          slug: rawTemplate.tail_service?.slug,
          writes: rawTemplate.tail_service?.writes,
        },
        services: (rawTemplate.services || []).map(rawService => ({
          id: rawService.id,
          image: rawService.image,
          name: rawService.name,
          reads: rawService.reads,
          slug: rawService.slug,
          writes: rawService.writes,
        })),
        title: rawTemplate.title,
        steps: rawTemplate.steps,
      });
    }

    if (!id) {
      setZapTemplate(null);
    } else {
      getZapTemplate();
    }
  }, [id, setIsLoading, setZapTemplate]);

  return {
    isLoading,
    zapTemplate,
  };
}
